import { PLACE_HOLDER } from 'src/constants';
import { buildAdVideoConfig } from './ad';

export const calHeightVideo = (
    width: number,
    height: number,
    clientWidth: any,
) => {
    const ratio = height / width;
    const calcWidth = clientWidth;
    return calcWidth * ratio;
};

const PLAYER_COMMON_OPTIONS = {
    pauseOnClick: true,
    mute: false,
    loop: false,
    volume: 100,
    playInline: 'playsinline',
    controls: {
        alwaysShowControl: false,
        seekBar: {
            foregroundColor: '#49AEBF',
        },
        volumeBar: {
            foregroundColor: '#49AEBF',
        },
        type: {
            fullWidth: {
                // style 2
                paddingTop: 10,
                backgroundImage:
                    'linear-gradient(to bottom, transparent, rgba(0, 0, 0, 0.6))',
            },
        },
    },
};

const getBasePlugins = (type: string | string[]) => {
    let dim, font;
    if (type.indexOf('desktop') >= 0) {
        dim = '60px';
        font = '40px';
    } else {
        dim = '60px';
        font = '40px';
    }
    return {
        BigPlayButtonPlugin: {
            disable: false,
            buttonStyles: {
                width: dim,
                height: dim,
                borderRadius: '10px',
                backgroundColor: 'rgba(22, 161, 177, .6)',
                border: 0,
            },
            iconStyles: {
                fontSize: font,
            },
        },
        PlayPauseFaceoutPlugin: {
            disable: false,
            buttonStyles: {
                width: dim,
                height: dim,
                borderRadius: '10px',
                backgroundColor: 'rgba(22, 161, 177, .6)',
                border: 0,
            },
            iconStyles: {
                fontSize: font,
            },
        },
        LoadingSpinnerPlugin: {
            showLabel: false,
        },
    };
};

export const getPlayerConfig = (
    playerRef: any,
    playerProps: any,
    type: string | string[],
    isNoads: any,
) => {
    let mime;
    let poster;
    let w: any = 0;
    let h: any = 0;
    let plugins;
    const p = type.indexOf('desktop') >= 0 ? 'baomoi_web' : 'baomoi_mobile';
    const src = playerProps.content;

    if (type.indexOf('tts') < 0) {
        mime = 'video/mp4';
        const contentId = playerProps.contentId;
        const publisherId = playerProps.publisherId;
        w = '100%';
        h = '100%';

        if (src.indexOf('m3u8') > 0) {
            mime = 'video/mpeg';
        }
        poster = playerProps.poster || PLACE_HOLDER.VIDEO;
        plugins = Object.assign(
            getBasePlugins(type),
            !isNoads ? buildAdVideoConfig(type, contentId, publisherId) : {},
        );
    } else {
        if (src.indexOf('m3u8') > 0) {
            mime = 'audio/x-m3u8';
        } else {
            mime = 'audio/x-m4a';
        }
    }

    const playerConfigs = Object.assign(PLAYER_COMMON_OPTIONS, {
        product: p,
        mimeType: mime,
        source: src,
        height: h,
        width: w,
        poster: poster ? poster : '',
        pluginsOptions: Object.assign(plugins || {}, {
            StatsPlugin: {
                trackingApi: [
                    'https://log.baomoi.com/zplayer',
                    'https://zplayer-trk.zdn.vn/track',
                ],
            },
        }),
    });
    return playerConfigs;
};

export const getPlayerPodcastConfig = (
    playerProps: { content: any, poster?: string },
    type: string | string[],
) => {
    let mime;
    let poster;
    let w = 0;
    let h = 0;
    let plugins;
    const p = type.indexOf('desktop') >= 0 ? 'baomoi_web' : 'baomoi_mobile';
    const src = playerProps.content;
    poster = playerProps.poster || PLACE_HOLDER.VIDEO;
    if (src.indexOf('m3u8') > 0) {
        mime = 'audio/x-m3u8';
    } else {
        mime = 'audio/x-m4a';
    }

    const playerConfigs = Object.assign(PLAYER_COMMON_OPTIONS, {
        product: p,
        mimeType: mime,
        source: src,
        height: h,
        width: w,
        poster: poster ? poster : '',
        pluginsOptions: Object.assign(plugins || {}, {
            StatsPlugin: {
                trackingApi: [
                    'https://log.baomoi.com/zplayer',
                    'https://zplayer-trk.zdn.vn/track',
                ],
            },
        }),
    });
    return playerConfigs;
};
